import type { FormStructure, DataToView } from './Form.types';

const generateDataToView = (form: FormStructure): DataToView => {
  const { ...dataToView } = form;
  return dataToView;
};

export default generateDataToView;
